import '../../css/content.css';
import React, {useContext, useLayoutEffect, useState} from 'react';
import { VideoContext } from '../../context/VideoContext';
import { VideoData } from "../../data/Videos";
import { VideoPlayerWithTranscript, VideoTitle } from "../VideoPlayer";
import VideoContainer from "../VideoContainer";
import Tooltip from '../Tooltip';

import huffCoughing from '../../img/huff-coughing.svg'
import inhaler from '../../img/inhaler.svg'
import pills from '../../img/pills.svg'
import group3440 from '../../img/group-3440.svg'

import lung1 from '../../img/lungs-01.png'
import lung2 from '../../img/lungs-02.png'
import lung3 from '../../img/lungs-03.png'
import lung4 from '../../img/lungs-04.png'

const Content1 = () => {

  const [mounted, setMounted] = useState(false);
  const [videoData, setVideoData] = useState({});
  const { currentDeepDiveIndex } = useContext(VideoContext);

  useLayoutEffect(() => {
    if (currentDeepDiveIndex !== 1) return;
    setVideoData(VideoData.find((video) => video.id === "843697954"));
    setMounted(true);
    return () => {
      setMounted(false);
    };
  }, [currentDeepDiveIndex]);

  return (
    <>
      {/* 1 */}
      <div id="partial-0" className="partial-container partial-container-3">
        <h3>Can MAC symptoms be managed?</h3>
        <p className="text-center my-5"><Tooltip>MAC lung disease</Tooltip> often causes your body to make more <Tooltip>mucus</Tooltip> and irritate your airways, which may lead to coughing, wheezing, and shortness of breath.</p>
      </div>

      {/* 2 */}
      <div id="partial-1" className="partial-container partial-container-4">
        <p className="!text-center my-5">There are some techniques that can help improve your symptoms, like huff coughing and inhalers. Huff coughing is less forceful than a full cough and can help clear <Tooltip>mucus</Tooltip> from your lungs. Inhalers reduce <Tooltip>inflammation</Tooltip> in the airways so more oxygen can get into your lungs.</p>
        <p className="!text-center my-5">However, keep in mind that these don’t get rid of the root cause, the <Tooltip>MAC</Tooltip> infection, or stop the progressive damage.</p>
        <div className="icon-container">
          <div>
            <img src={huffCoughing} alt="huff coughing" />
            <p className="small">HUFF COUGHING</p>
          </div>
          <div>
            <img src={inhaler} alt="inhaler" />
            <p className="small">INHALERS</p>
          </div>
        </div>
      </div>

      {/* 3 */}
      <div id="partial-2" className="partial-container partial-container-5">
        <p>Antibiotics can be critical for clearing the <Tooltip>MAC</Tooltip> infection. That’s why it’s important to discuss a well-rounded treatment plan with your doctor, which may include antibiotics to get you MAC-negative.</p>
        <div className="img-container">
          <img src={pills} alt="pills" />
          <img src={group3440} alt="" />
        </div>
        <p className="small">ANTIBIOTICS</p>
      </div>

      {/* 4 */}
      <div id="partial-3" className="partial-container partial-container-6">
      <div className="min-h-fit">
        <h3 className="">Here’s an example of a well-rounded treatment plan</h3>

        <div className="lung-container">
          <img src={lung1}/>
          <div>
            <p>
              <strong>Exercise:</strong><br/>
              Increases oxygen in your blood
            </p>
          </div>
        </div>

        <div className="lung-container">
          <img src={lung2}/>
          <div>
            <p>
              <strong>Nutrition:</strong><br/>
              Reduces <Tooltip>inflammation</Tooltip>
            </p>
          </div>
        </div>

        <div className="lung-container">
          <img src={lung3}/>
          <div>
            <p>
              <strong>Airway clearance techniques:</strong><br/>
              Clears <Tooltip>mucus</Tooltip> from your lungs
            </p>
          </div>
        </div>

        <div className="lung-container">
          <img src={lung4}/>
          <div>
            <p>
              <strong>Antibiotic treatments:</strong><br/>
              Clears the infection
            </p>
          </div>
        </div>
        </div>
      </div>

      {/* 5 */}
      <div id="partial-4" className="partial-container partial-container-7">
        <div className="min-h-fit">
          {
            (mounted) && 
            <>
              <VideoTitle>{videoData.title}</VideoTitle>
              <VideoContainer>
                <VideoPlayerWithTranscript videoData={videoData} />
              </VideoContainer> 
            </>
          }
        </div>
      </div>
    </>
  )
};

export default Content1;